import tw from 'tailwind-styled-components'

export const Title = tw.p`
w-[260px] 
leading-[27px]
text-[#474747] 
font-semibold
text-lg 
`

export const ContenTitle = tw.p`
text-[#005EB8] 
w-[width: 1120px] 
text-sm/[14px] 
leading-[21px] 
my-2
`

export const SubtitleForm = tw.p`
text-[#474747] 
w-[width: 1120px] 
text-sm/[14px] 
leading-[21px] 
`
export const Subtitle = tw.p`
text-[#474747] 
w-[width: 1120px] 
text-sm/[14px] 
leading-[21px] 
my-2
`
export const LabelGeneralInfo = tw.p`
text-[#474747]/80 
text-[12px] 
leading-[18px] 
mb-[0.2rem]
p-0
`
export const LabelGeneralForumPage = tw.p`
text-[#474747]/80 
text-[12px] 
leading-[18px] 
mb-[0.2rem]
p-0
`
export const DescriptionTag = tw.p`
text-[#474747]
text-[12px] 
leading-[18px] 
mb-[0.2rem]
p-0
`
export const ValueGeneralInfoForumPage = tw.p`
text-darkGray
text-[14px] 
font-bold 
`
export const ValueGeneralInfoSemiBoldForumPage = tw.p`
text-darkGray
text-sm
font-semibold
`
export const ValueGeneralInfo = tw.p`
text-darkGray/80 
text-[16px] 
font-bold 
`

export const HelpDescription = tw.p`
text-darkGray/80 
text-xs
leading-[18px]
w-[1120px] 
`

export const TypeOptionsBlock = tw.p`
text-blueTheme
mt-6
text-xs
text-[16px] 
font-bold 
`
export const CreateButton = tw.button`
font-semibold
text-sm
text-white
bg-blueTheme
p-2
rounded-lg
h-[38px]
mt-[200px];
px-6
hover:brightness-95
transition-all
active:scale-95
w-[263px]
`

export const ContainerForm = tw.div`
md:mx-12
mx-6
md:my-8
my-4
bg-white
boxShadow
rounded-lg
min-w-[380px]
relative
pb-6
`
export const MainForm = tw.form`
flex
flex-col
justify-center

`
export const ContentForm = tw.div`
grid 
grid-cols-3 
gap-2 
w-full
mt-6
`

export const Label = tw.label`
block 
font-semibold
text-xs
text-darkGray
truncate
pb-1
`
export const Top = tw.div`
flex-wrap
flex 
justify-between
ml-8
mb-6
`

export const TopInputs = tw.div`
flex 
flex-wrap
gap-4
mr-6
ml-auto
`

export const TitleForm = tw.div`
text-[18px]
font-bold
text-blueTheme
`

export const inputRequiredStyle = `
border
border-errorText
focus:ring-0
focus:border
focus:border-errorText
`

export const SaveButton = tw.button`
font-semibold
text-sm
text-white
bg-blueTheme
p-2
rounded-lg
h-[38px]
px-6
hover:brightness-95
transition-all
active:scale-95
w-[90px]
`

export const BackButton = tw.button`
px-6
w-[90px]
h-[38px]
inline-flex
items-center
justify-center
border
rounded-lg
border-blueTheme
text-blueTheme
text-sm
cursor-pointer
active:scale-95
transition-colors
hover:brightness-90
`

export const InputInfoLabelTitle = tw.p`
font-semibold
text-xs
text-darkGray
`

export const InfoInputsWrapper = tw.div`
mx-6
overflow-x-hidden
flex
flex-col
gap-6
max-h-[420px]
`

export const InputInfoLabelSubTitle = tw.p`
text-xs
text-darkGray/80
`

export const textAreaStyles = `
max-w-full 
max-h-[257px] 
h-[257px]
`
export const textAreaSmallStyles = `
max-w-full 
max-h-[105px] 
h-[105px]
`
export const factorsLabelStyle = `
text-[#474747] 
w-[width: 1120px] 
text-sm/[14px] 
leading-[21px] my-2
cursor-pointer
`
export const notPerformStyle = `
inline-block pl-[0.15rem] hover:cursor-pointer
`

export const horizontalRowLine = `
my-5 
border-[1px] 
w-[1120px] 
border-[#EBEDF2]
`

export const checkboxStyle = `
text-amberAlt
relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] 
border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] 
before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] 
before:content-[''] checked:border-primary checked:bg-yellow-400 checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px 
checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 
checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white 
checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] 
hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] 
focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] 
focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block 
focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-['']
checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#005EB8] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] 
checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 
checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent 
dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] 
dark:checked:focus:before:shadow-[0px_0px_0px_13px_#FFFFFF]
focus:outline-blueTheme  
`;

export const checkboxDisabledStyle = `
bg-disabled hover:brightness-100 opacity-90 text-[#4F4F4F]
relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] 
border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem]
`;

export const StaticDataContainer = tw.div`
px-8
`

export const EditButton = tw.button`
font-semibold
text-sm
text-white
bg-blueTheme
p-2
rounded-lg
h-[38px]
px-6
hover:brightness-95
transition-all
active:scale-95
w-[263px]
`
export const Content = tw.div`
grid 
grid-cols-3 
gap-2 
w-full
mt-6
`